import { c as _c } from "react/compiler-runtime";
import { Badge, Loader } from '@systemeio/components';
import { NavigationTitle } from 'modules/funnels/funnel/components/navigation-title';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface StepsTitleProps {
  count: number | undefined;
}
export const StepsTitle = t0 => {
  const $ = _c(12);
  const {
    count
  } = t0;
  const {
    tICU
  } = useLocoTranslation();
  const t1 = count ?? 0;
  let t2;
  if ($[0] !== t1 || $[1] !== tICU) {
    t2 = tICU("dashboard.funnel.steps.title", {
      count: t1
    });
    $[0] = t1;
    $[1] = tICU;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <NavigationTitle>{t2}</NavigationTitle>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== count) {
    t4 = count ?? <Loader />;
    $[5] = count;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <Badge color="lightGray" size="lg" shape="pill">{t4}</Badge>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div className="desktop:py-5 flex items-center justify-between py-3">{t3}{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};